export const FETCH_PROGRAM_DISCUSSIONS_REQUEST = 'FETCH_PROGRAM_DISCUSSIONS_REQUEST';
export const FETCH_PROGRAM_DISCUSSIONS_SUCCESS = 'FETCH_PROGRAM_DISCUSSIONS_SUCCESS';
export const FETCH_PROGRAM_DISCUSSIONS_FAILURE = 'FETCH_PROGRAM_DISCUSSIONS_FAILURE';
export const FETCH_PROGRAM_LIVE_REQUEST = 'FETCH_PROGRAM_LIVE_REQUEST';
export const FETCH_PROGRAM_LIVE_SUCCESS = 'FETCH_PROGRAM_LIVE_SUCCESS';
export const FETCH_PROGRAM_LIVE_FAILURE = 'FETCH_PROGRAM_LIVE_FAILURE';
